export const categories = [
  {
    id: 'life',
    name: '生活',
    icon: 'ri-home-smile-2-line',
    color: 'primary',
    description: '收纳整理、生活方式、日常感悟、居家好物，把日子过成想要的样子。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20warm%20minimal%20home%20interior%20with%20plants%20and%20cream%20tones%2C%20morning%20sunlight%20through%20window%2C%20soft%20honey%20orange%20accents%2C%20lifestyle%20editorial%20photography&width=900&height=600&seq=hc-cat-life&orientation=landscape',
    topicCount: 1286,
  },
  {
    id: 'entertainment',
    name: '娱乐',
    icon: 'ri-movie-2-line',
    color: 'accent',
    description: '影视、音乐、综艺、演出，聊聊那些让你上头的好作品。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20vintage%20cinema%20seats%20with%20soft%20amber%20lighting%2C%20retro%20film%20and%20music%20theme%2C%20cozy%20cinematic%20editorial%20photography%2C%20orange%20tone&width=900&height=600&seq=hc-cat-ent&orientation=landscape',
    topicCount: 964,
  },
  {
    id: 'culture',
    name: '文化',
    icon: 'ri-book-open-line',
    color: 'secondary',
    description: '读书、历史、艺术、传统，在文字与器物之间慢慢生长。',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20old%20books%20with%20warm%20beige%20paper%20and%20a%20ceramic%20teacup%2C%20soft%20natural%20light%2C%20quiet%20literary%20mood%2C%20warm%20editorial%20photography&width=900&height=600&seq=hc-cat-culture&orientation=landscape',
    topicCount: 742,
  },
  {
    id: 'tech',
    name: '技术',
    icon: 'ri-code-s-slash-line',
    color: 'secondary',
    description: '编程、数码、AI、极客玩具，和爱折腾的人一起分享经验。',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20desk%20setup%20with%20laptop%20and%20keyboard%2C%20warm%20orange%20ambient%20light%2C%20clean%20modern%20workspace%2C%20soft%20editorial%20photography&width=900&height=600&seq=hc-cat-tech&orientation=landscape',
    topicCount: 638,
  },
  {
    id: 'food',
    name: '美食',
    icon: 'ri-restaurant-2-line',
    color: 'primary',
    description: '家常菜、烘焙、探店、一人食，认真吃饭就是认真生活。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20rustic%20table%20with%20fresh%20baked%20pastry%20and%20honey%2C%20soft%20natural%20light%2C%20clean%20food%20editorial%20photography%2C%20amber%20tones&width=900&height=600&seq=hc-cat-food&orientation=landscape',
    topicCount: 1105,
  },
  {
    id: 'travel',
    name: '旅行',
    icon: 'ri-flight-takeoff-line',
    color: 'accent',
    description: '路线、攻略、露营、城市漫步，把世界读成一本书。',
    image: 'https://readdy.ai/api/search-image?query=Scenic%20mountain%20road%20at%20golden%20hour%20with%20warm%20sunset%20light%2C%20travel%20backpack%20in%20foreground%2C%20soft%20honey%20orange%20tones%2C%20editorial%20travel%20photography&width=900&height=600&seq=hc-cat-travel&orientation=landscape',
    topicCount: 857,
  },
];